import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

export interface FiltroSelectOption {
  value: any;
  label: string;
}

@Component({
  selector: 'app-filtro-select',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './filtro-select.component.html',
  styleUrl: './filtro-select.component.scss',
})
export class FiltroSelectComponent {
  @Input() value: any;
  @Input() options: FiltroSelectOption[] = [];
  @Input() placeholder = '';
  @Input() defaultValue: any = null;
  @Input() disabled = false;

  @Output() valueChange = new EventEmitter<any>();

  onChange(value: any): void {
    this.value = value;
    this.valueChange.emit(value);
  }
}
